import {Component, OnDestroy, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {TransitionService, Transition, UIRouterGlobals} from '@uirouter/core';

@Component({
    selector: 'app-bootstrap',
    templateUrl: './app.bootstrap.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppBootstrapComponent implements OnInit, OnDestroy {

  constructor(private renderer: Renderer2,
              private transitionService: TransitionService,
              private globals: UIRouterGlobals) {
  }

  ngOnInit(): void {
    this.updateBodyClass(this.globals.current.name);
    this.transitionService.onSuccess({to: '**'}, (transition: Transition) => {
      this.updateBodyClass(transition.targetState().name());
    }, {priority: 100});
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'envisiabody');
  }

  private updateBodyClass(stateName: string): void {
    if (stateName.startsWith('a')) {
      this.renderer.addClass(document.body, 'envisiabody');
    } else {
      this.ngOnDestroy();
    }
  }

}
